<template lang="pug">
  .error-container.flex.content-center.justify-center.flex-wrap
    section.text-center
      h1.title(v-if="code") Error {{ code }}
      h3.subtitle(v-if="message") {{ message }}
</template>

<script>
export default {
    name: 'Error',
    props: {
        code: {
            type: Number,
            required: false
        },
        message: {
            type: String,
            required: false
        }
    }
};
</script>

<style lang="sass" scoped>

.error-container
  min-height: 100%
  flex-grow: 1
  color: #aaacb5

  .title
    line-height: 1
    font-size: 6em
    font-weight: 150
    margin-bottom: 10px

  .subtitle
    font-size: 2em
    font-weight: 300
    margin-top: 10px
    // margin-bottom: 80px
    // text-transform: uppercase
</style>
